import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../Styles/Common.module.css';
import Button from '../Styles/Button.module.css';
import { Link } from "react-router-dom";
import { IoArrowForwardCircleOutline } from "react-icons/io5";


const CommunityComponents = ()=>{

    const smoothScroll = () => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      };

    return( 
        <div className={Style.communitySec + ' ' + Style.componentsSpace}>
            <Container>
                <Row>
                    <Col>
                        <div className={Style.sectionTitle}>
                            <h2>Community</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={4} className={Style.tabWidth}>
                        <div className={Style.communityContainer}>
                            <figure>
                                <img src={require('../../assest/images/community-img03.png')} />
                            </figure>
                            <div className={Style.communitelement}>
                                <img src={require('../../assest/images/alumni-icon.png')} />
                                <h3><Link  onClick={smoothScroll} to='/alumni-directory'>Alumni Directory</Link></h3>
                                <p>Search Batchmates & Connect With Mayo Alumni Community.</p>
                                <Link onClick={smoothScroll} to='/alumni-directory' className={Button.goGreenBtn + ' ' + Style.communityLink}><IoArrowForwardCircleOutline /></Link>
                            </div>
                        </div>
                    </Col>
                    <Col md={4} className={Style.tabWidth}>
                        <div className={Style.communityContainer}>
                            <figure>
                                <img src={require('../../assest/images/community-img02.png')} />
                            </figure>
                            <div className={Style.communitelement}>
                                <img src={require('../../assest/images/business-icon.png')} />
                                <h3><Link onClick={smoothScroll} to='/business-directories' >Business Directory</Link></h3>
                                <p>Search Alumni Business Directory & Connect With Mayo Alumni Business Community</p>
                                <Link onClick={smoothScroll} to='/business-directories' className={Button.goGreenBtn + ' ' + Style.communityLink}><IoArrowForwardCircleOutline /></Link>
                            </div>
                        </div>
                    </Col>
                    <Col md={4} className={Style.tabWidth}>
                        <div className={Style.communityContainer}>
                            <figure>
                                <img src={require('../../assest/images/community-img01.png')} />
                            </figure>
                            <div className={Style.communitelement}>
                                <img src={require('../../assest/images/job-icon1.png')} />
                                <h3><Link onClick={smoothScroll} to='/jobs'>Jobs</Link></h3>
                                <p>Post Jobs Openings, Search & Apply For Jobs Posted By Mayo Alumni Community</p>
                                <Link onClick={smoothScroll} to='/jobs' className={Button.goGreenBtn + ' ' + Style.communityLink}><IoArrowForwardCircleOutline /></Link>
                            </div>
                        </div>
                    </Col>
                    <Col md={4} className={Style.tabWidth}>
                        <div className={Style.communityContainer}>
                            <figure>
                                <img src={require('../../assest/images/community-img01.png')} />
                            </figure>
                            <div className={Style.communitelement}>
                                <img src={require('../../assest/images/job-icon1.png')} />
                                <h3><Link onClick={smoothScroll} to='/post'>Posts</Link></h3>
                                <p>Submit & View Announcements, Updates & News posted by Mayo Alumni Community</p>
                                <Link onClick={smoothScroll} to='/post' className={Button.goGreenBtn + ' ' + Style.communityLink}><IoArrowForwardCircleOutline /></Link>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default CommunityComponents;